import Auth from "../Auth";
import AuthService from "../Auth/AuthService";

const tokenInterceptor = async (config) => {
    const token = Auth.getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
};

const responseSuccessInterceptor = async response => response?.data?.data;
const responseErrorInterceptor = async error => {
    if (error.response && error.response.status === 401) {
        AuthService.logout();
        window.location.href = `${window.location.origin}/login?redirect=${encodeURIComponent(window.location.href.replace(window.location.origin, ''))}`;
    }
    return Promise.reject(error);
};

export {
    tokenInterceptor,
    responseSuccessInterceptor,
    responseErrorInterceptor
}